module.exports = __webpack_public_path__ + "img/impostor-silhouete-bg-2.d5612f3f.png";